import { createAppStore } from "./createAppStore";

export default function configureStore(preloadedState) {
  return createAppStore(preloadedState, { devTools: true });
}
